export default {
  enter_vin: {
    component: "EnterVin"
  },
  result_badly: {
    component: "EnterVin"
  },
  result_ok: {
    component: "EnterVin"
  },
  result_not_found: {
    component: "EnterVin"
  },
  result_grey: {
    component: "Result"
  },
  result: {
    component: "Result"
  },
  service_request: {
    component: "ServiceRequest"
  }
};
